import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import { useSaveTransferMutation } from "../../services/hr.service";
import { Select } from "antd";
import { useLazySearchEmployeesQuery } from "../../services/employee.service";
import { useForm, Controller } from "react-hook-form";
import { ClipLoader } from "react-spinners";
import { customStyles } from "../../utils";
import { TransferSchema } from "../../utils/validationSchema";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import dayjs from "dayjs";
import alertify from "alertifyjs";
import { useGetBranchesQuery } from "../../services/settings.service";

const { Option } = Select;

const TransferModal = ({item}) => {
  const {user} = useSelector((state) => state.user);

  const branch_id = (!['HR Admin', 'Admin', 'HR Assistant'].includes(user?.role)) ? user?.branch?.id : ''
  const [employees, setEmployees] = useState([]);
  const [searchEmployees, {data: searchData, error: searchError}] = useLazySearchEmployeesQuery();
  const [saveResignation, {data, isLoading, isSuccess, error}] = useSaveTransferMutation();
  const {data: branches} = useGetBranchesQuery();

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(TransferSchema),
  });

  useEffect(() => {
    if (searchData) {
      setEmployees(searchData?.data)
    }
  }, [searchData, searchError])

  useEffect(() => {
    if (isSuccess && data?.success){
      alertify.success(data?.message);
      document.getElementById('close-modal').click();

      setValue('employee_id', "");
      setValue('branch_id', "");
      setValue('transfer_date', "");
      setValue('id', "");
    }

    if (data && !data.success)
      alertify.error(data.errors);

    if (error) 
      alertify.error(error?.message);

  }, [data, error, isSuccess]);

  useEffect(() => {
    if (item) {
      setEmployees([...employees, {
        id: item.employee.id,
        name: item.employee.first_name + ' ' + item.employee.last_name,
        designation: item.employee.designation,
        department: item.department
      }]);
      setValue('employee_id', item.employee.id);
      setValue('branch_id', item.new_branch?.id);
      setValue('transfer_date', dayjs(item.transfer_date).toDate());
      setValue('id', item.id);
    }
  }, [item]);

  const findEmployees = (value) => {
    if (value) {
      searchEmployees({q:value, branch_id});
    } else {
      setEmployees([]);
    }
  }

  const save = payload => {
    payload.transfer_date = dayjs(payload.transfer_date).format('YYYY-MM-DD');
    saveResignation(payload);
  }

  return (
    <>
      {/* Add Promotion Modal */}
      <div id="transfer_modal" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{item ? 'Edit' : 'Add'} Tranfer</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="close-modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(save)}>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Employee <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="employee_id"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                        showSearch
                        size="large"
                        value={value}
                        style={{width: '100%'}}
                        defaultActiveFirstOption={false}
                        filterOption={false}
                        onSearch={findEmployees}
                        onChange={(value) => {
                          onChange(value);
                          const employee = employees.find(employee => employee.id === value);
                          if (employee) {
                              setValue('current_branch', employee.branch.name);
                          }
                        }}
                        notFoundContent={null}
                      >
                        {employees.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>)}
                      </Select>
                    )}
                  />
                  <span className="text-danger">
                      {errors?.employee_id?.message}
                  </span>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Current Branch <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="current_branch"
                    control={control}
                    render={({ field: { value } }) => (
                      <input
                        className="form-control"
                        type="text"
                        // defaultValue="Web Developer"
                        value={value}
                        readOnly
                      />
                    )}
                  />
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Transfer To <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="branch_id"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <Select
                          size="large"
                          value={value}
                          placeholder="Select "
                          styles={customStyles}
                          style={{width: '100%'}}
                          onChange={onChange}
                        >
                          {branches?.data.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>)}
                        </Select>
                    )}
                  />
                  <span className="text-danger">
                        {errors?.branch_id?.message}
                    </span>
                </div>
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Transfer Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <Controller
                      name="transfer_date"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <DatePicker
                          selected={value || null}
                          onChange={onChange}
                          className="form-control floating datetimepicker"
                          type="date"
                          dateFormat="dd-MM-yyyy"
                        />
                      )}
                    />
                    <span className="text-danger">
                      {errors?.transfer_date?.message}
                    </span>
                  </div>
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    disabled={isLoading}
                  >
                    {!isLoading ? 'Submit' : <ClipLoader color="#ffffff" />}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Promotion Modal */}
    </>
  );
};

export default TransferModal;
